import { definePreset as c } from "@pandacss/dev";
import { fontsConfig as n, Themes as t, colorSemanticTokens as i, radiusSemanticTokens as f, spacingPrimitives as l, colorPrimitives as d, fontWeightPrimitives as g, spacingSemanticTokens as s, fontSizePrimitives as k, typeFacePrimitives as u, shadows as T, blur as b } from "@huspy/briks-core";
import { buildThemeColors as e } from "../utils/build-theme-colors.mjs";
import { format as o, toPandaObject as h } from "../utils/format.mjs";
import { transformSpacings as a, pixify as r, transformSemanticToken as p, transformFontWeight as S } from "../utils/transform.mjs";
import { datePickerRecipe as y } from "../components/date-picker/date-picker-recipe.mjs";
import { checkboxRecipe as P } from "../components/checkbox/checkbox-recipe.mjs";
import { iconButton as R } from "../components/icon-button/icon-button-recipe.mjs";
import { input as x, inputDescription as v, inputLabel as C } from "../components/input/input-recipe.mjs";
import { phoneInput as w } from "../components/phone-input/phone-input-recipe.mjs";
import { chipRecipe as z } from "../components/chip/chip-recipe.mjs";
import { propertyTag as F } from "../components/property-tag/property-tag-recipe.mjs";
import { button as I } from "../components/button/button-recipe.mjs";
import { text as W, title as B } from "../components/typography/typography-recipe.mjs";
import { pinInput as H } from "../components/pin-input/pin-input-recipe.mjs";
import { propertyCardRecipe as U } from "../blocks/property-card/recipe.mjs";
import { popover as j } from "../components/popover/popover-recipe.mjs";
import { slider as D } from "../components/slider/slider-recipe.mjs";
import { progress as G } from "../components/progress/progress-recipe.mjs";
import { sidebarMenu as L } from "../blocks/sidebar-menu/sidebar-menu-recipe.mjs";
import { modal as M } from "../blocks/modal/modal-recipe.mjs";
import { multiFileUpload as O } from "../blocks/multi-file-upload/multi-file-upload-recipe.mjs";
import { alert as q } from "../components/alert/alert-recipe.mjs";
import { dialog as A } from "../components/dialog/dialog-recipe.mjs";
import { radioGroup as E } from "../components/radio/radio-recipe.mjs";
import { fileUpload as J } from "../components/file-upload/file-upload-recipe.mjs";
import { tableRecipe as K } from "../components/table/table-recipe.mjs";
import { pagination as N } from "../components/pagination/pagination-recipe.mjs";
import { combobox as Q } from "../components/combobox/combobox-recipe.mjs";
import { select as V } from "../components/select/select-recipe.mjs";
import { badgeRecipe as X } from "../components/badge/badge-recipe.mjs";
import { propertyChip as Y } from "../components/property-chip/property-chip-recipe.mjs";
import { numberInput as Z } from "../components/number-input/number-input-recipe.mjs";
import { switchRecipe as _ } from "../components/switch/switch-recipe.mjs";
import { toastRecipe as $ } from "../components/toast/toast-recipe.mjs";
import { propertyBadge as oo } from "../components/property-badge/property-badge-recipe.mjs";
import { spinner as ro } from "../components/spinner/spinner-recipe.mjs";
import { drawer as to } from "../components/drawer/drawer-recipe.mjs";
import { skeleton as io } from "../components/skeleton/skeleton-recipe.mjs";
import { layout as eo } from "../blocks/layout/layout-recipe/layout-recipe.mjs";
import { sidebar as mo } from "../blocks/sidebar/sidebar-recipe/sidebar-recipe.mjs";
const po = a(f, "radius-"), m = o(r(a(l, "spacing-"))).toToken(), no = o(p(po)).toSemanticToken("spacing"), Yo = c({
  conditions: {
    light: "[data-color-mode=light] &",
    dark: "[data-color-mode=dark] &"
  },
  theme: {
    extend: {
      recipes: {
        text: W,
        title: B,
        button: I,
        iconButton: R,
        input: x,
        inputDescription: v,
        inputLabel: C,
        chipRecipe: z,
        propertyTag: F,
        propertyChip: Y,
        badgeRecipe: X,
        spinner: ro,
        propertyBadge: oo,
        skeleton: io
      },
      slotRecipes: {
        checkboxRecipe: P,
        phoneInput: w,
        pinInput: H,
        propertyCardRecipe: U,
        popover: j,
        slider: D,
        progress: G,
        sidebarMenu: L,
        alert: q,
        datePickerRecipe: y,
        dialog: A,
        modal: M,
        radioGroup: E,
        fileUpload: J,
        tableRecipe: K,
        pagination: N,
        combobox: Q,
        select: V,
        numberInput: Z,
        switchRecipe: _,
        multiFileUpload: O,
        toastRecipe: $,
        drawer: to,
        layout: eo,
        sidebar: mo
      },
      tokens: {
        colors: o(h(d)).toToken(),
        fontSizes: o(r(k)).toToken(),
        spacing: m,
        sizes: m,
        fontWeights: o(S(g)).toToken(),
        lineHeights: o(r(n.sansSerif.lineHeight)).toToken(),
        letterSpacings: o(r(n.sansSerif.letterSpacing)).toToken(),
        fonts: o(u).toToken(),
        radii: m,
        shadows: o(T).toToken(),
        blurs: o(b).toToken()
      },
      semanticTokens: {
        colors: e(i, t.rebu),
        spacing: o(p(s)).toSemanticToken("spacing"),
        sizes: o(p(s)).toSemanticToken("spacing"),
        radii: { ...no, full: { value: "9999px" } }
      }
    }
  },
  themes: {
    extend: {
      mortgage: {
        tokens: {
          colors: e(i, t.mortgage)
        }
      },
      bayteca: {
        tokens: {
          colors: e(i, t.bayteca)
        }
      }
    }
  },
  staticCss: {
    themes: ["mortgage", "bayteca"]
  }
});
export {
  Yo as briksPreset
};
